export default class Constants {
    static get API_BASE_URL() { return window.API_BASE_URL }
    static get BASE_URL() { return window.BASE_URL }
    static get AUTH_API_BASE_URL() { return window.AUTH_API_BASE_URL }
    static get AUTH_BASE_URL() { return window.AUTH_BASE_URL }
    static get TAX_SERVICE_URL() { return window.TAX_SERVICE_URL }
}